module.exports = __webpack_public_path__ + "img/far-edit.ec41be63.svg";